import { useState, useEffect } from 'react';

/**
 * 🚀 Hook useDebounce pour optimiser les recherches temps réel
 * Évite les appels API excessifs en retardant l'exécution
 * 
 * @param {any} value - Valeur à débouncer
 * @param {number} delay - Délai en millisecondes (défaut: 300ms)
 * @returns {any} - Valeur débouncée
 */
export const useDebounce = (value, delay = 300) => {
  const [debouncedValue, setDebouncedValue] = useState(value);

  useEffect(() => {
    // Créer un timer qui met à jour la valeur débouncée après le délai
    const handler = setTimeout(() => {
      setDebouncedValue(value);
    }, delay);

    // Nettoyer le timer si value ou delay change
    return () => {
      clearTimeout(handler);
    };
  }, [value, delay]);

  return debouncedValue;
};

export default useDebounce;
